var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent", staticStyle: { height: "calc(100vh - 50px)" } },
    [
      _c("layout-3", {
        staticStyle: { "max-height": "30vh" },
        attrs: { id: _vm.pageid1, term: _vm.term, width: 3, height: 1 }
      }),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "overflow-y": "auto", "margin-bottom": "80px" } },
        [
          _vm.perms.includes("56")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Job Orders",
                  id: _vm.pageid2,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "2",
                  button_name: "Select",
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("56")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Sister Vessels",
                  id: _vm.pageid3,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "56",
                  button_name: "Select",
                  term: _vm.term,
                  hide_first_column: true
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("56")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Same IMO Number",
                  id: _vm.pageid4,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "56",
                  button_name: "Select",
                  term: _vm.term,
                  hide_first_column: true
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("61")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Tech Documents",
                  id: _vm.pageid5,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "61",
                  button_name: "Select",
                  term: _vm.term,
                  hide_first_column: true
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.default_vesselpic != ""
            ? _c(
                "div",
                [
                  _c("vesselpic", {
                    staticStyle: {
                      width: "50%",
                      height: "calc(50%)",
                      margin: "auto"
                    },
                    attrs: {
                      dir:
                        "vesselpics/vesselpic_" +
                        parseInt(_vm.default_vesselpic) +
                        ".jpg",
                      vesselpic_id: _vm.default_vesselpic
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c("div", [
          _vm.perms.includes("61")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.button("Add")
                    }
                  }
                },
                [_vm._v("Add Tech Document")]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39ee806b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39ee806b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/View_Vessel_History.vue
// module id = 541
// module chunks = 0